/**
 * Whether an extracted value would render anything. Truthiness is not enough: extraction
 * yields `{}`, blank strings and arrays of empty items, which all pass a `!data` check and
 * render an empty frame. Mirrors `hasContent` in the api's `analysis-report-sections.ts`,
 * which decides `missingSections` by the same rule.
 */
export function hasContent<T>(value: T): value is NonNullable<T> {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.some(hasContent);
  if (typeof value === 'object') return Object.values(value).some(hasContent);
  return true;
}
